<template>
  <div class="h-100">
    <div class="match-card match-card__try-again text-center" v-if="show">

      <div class="match-card__desc">
        <div class="title title--large title--white">
          {{ trans.get('pages:match_game.free_matchgames_over_card.header') }}
        </div>

        <div class="desc desc--white my-1">
          {{ trans.get('pages:match_game.free_matchgames_over_card.slogan') }}
        </div>
      </div>

      <div class="match-card__image" v-if="avatars.length">
        <div class="avatar-triple">
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[0] + '?h=100)'}">
          </div>
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[1] + '?h=200)'}">
          </div>
          <div class="avatar-triple__image" :style="{'background-image':'url(' + avatars[2] + '?h=100)'}">
          </div>
        </div>
      </div>

      <div class="match-card__coins">
        <div class="title title--large title--white"><strong>{{ tryAgainValue }}</strong> <i class="demo-icon icon-n-lova-coins"></i></div>
      </div>

      <div v-if="false" class="match-card__approval">
        <div class="checkbox-standard">
          <label>
            <input type="checkbox" v-model="paymentApproval">
            <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2"></span>

            <span class="desc desc--white"> {{ trans.get('pages:match_game.free_matchgames_over_card.confirm_label') }}</span>
          </label>
        </div>
      </div>

      <div class="match-card__button">
        <button class="button button__outline button__outline--white-hov-purple" @click="buyAction()">{{ trans.get('pages:match_game.free_matchgames_over_card.try_again_button') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NoMoreMatchesCard',
  props: {
    current: Object,
  },
  data() {
    return {
      paymentApproval: false,
      tryAgainValue: null,
      show: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    }
  },
  methods: {
    buyAction() {
      axios
        .post(zRoute('ajax.match_game.match_try_again'), {
          agreement: this.paymentApproval,
        })
        .then(response => {
          this.$emit('load');
        })
        .catch(error => {
          const data = error.response.data;
          if (data.status === 'error') {
            this.$emit('errorReason', data.reason);
          }
        });
    },
  },
  mounted() {
    this.tryAgainValue = window.globals.settings_payment_match_game;

    if (this.isPaymentApproved(window.globals.user.payment_approval_match_game)) {
      this.buyAction();
    } else {
      this.show = true;
    }
  }
};
</script>


